// Простая утилита для определения языка и страны по IP (клиентская геолокация)
// Запрашиваем через backend, чтобы не зависеть от CORS сторонних geo API.

import api from './axios';

const CIS_COUNTRY_CODES = new Set([
  'KZ', 'RU', 'BY', 'UA', 'UZ', 'KG', 'TJ', 'TM', 'AM', 'AZ', 'MD'
]);

const CHINA_CODES = new Set(['CN', 'HK', 'MO', 'TW']);

function chooseLanguageByGeo(countryCode, continentCode) {
  if (countryCode && CHINA_CODES.has(countryCode)) return 'zh';
  if (countryCode && CIS_COUNTRY_CODES.has(countryCode)) return 'ru';
  if (continentCode && (continentCode === 'EU' || continentCode === 'NA' || continentCode === 'SA')) return 'en';
  return 'ru';
}

export async function detectLocaleAndCountry() {
  try {
    const response = await api.get('/geo/detect', { skipAuthRedirect: true });
    const data = response?.data || {};
    const countryCode = data?.countryCode || '';
    const continentCode = data?.continentCode || '';
    const lang = chooseLanguageByGeo(countryCode, continentCode);
    return { countryCode, lang };
  } catch (error) {
    return { countryCode: '', lang: 'ru' };
  }
}

export function persistDetectedPrefs(lang, countryCode) {
  try {
    if (lang) localStorage.setItem('user-language', lang);
    if (countryCode) localStorage.setItem('user-country', countryCode);
  } catch (_) {
    // ignore
  }
}
